export default "__VITE_ASSET__eSDoTO3V__"